import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward, faTruck, faScrewdriverWrench, faTag } from '@fortawesome/free-solid-svg-icons';
import { useScrollAnimation } from '../../helpers/useScrollAnimation';
import './About.css';

const features = [
    { key: 'aboutFeature1', icon: faAward },
    { key: 'aboutFeature2', icon: faTruck },
    { key: 'aboutFeature3', icon: faScrewdriverWrench },
    { key: 'aboutFeature4', icon: faTag },
];

export const About = () => {
    const { t } = useTranslation();
    const sectionRef = useScrollAnimation();

    return (
        <section id="about" className="section" ref={sectionRef}>
            <div className="container">
                <div className="about-grid">
                    <div className="about-text-col fade-left">
                        <span className="section-label">{t("aboutLabel")}</span>
                        <h2 className="section-title">{t("aboutTitle")}</h2>
                        <p className="about-text">{t("aboutText")}</p>
                    </div>
                    <div className="about-features-col fade-right">
                        {features.map(({ key, icon }) => (
                            <div className="about-feature" key={key}>
                                <div className="about-feature-icon">
                                    <FontAwesomeIcon icon={icon} />
                                </div>
                                <span>{t(key)}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
